import { GetUserProfileAndPermissions } from '@carrier-sce-sharedpackages/reactauthwrapper';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/layout/Layout';
import Department from './pages/Department';
import DepartmentManagement from './pages/DepartmentManagement';
import DetailedList from './pages/DetailedList';
import EstimateReview from './pages/EstimateReview';
import ExecutionDepartment from './pages/ExecutionDepartment';
import ExecutionReview from './pages/ExecutionReview';
import FinalReview from './pages/FinalReview';
import GlobalCoordinatorReview from './pages/GlobalCoordinatorReview';
import HomePage from './pages/Home';
import ListPage from './pages/ListPage';
import ResourceModification from './pages/ListTableAndTrackingFIle/ResourceModification';
import TrackingFile from './pages/ListTableAndTrackingFIle/TrackingFile';
import LocalSiteReview from './pages/LocalSiteReview';
import MyPecr from './pages/MyPecr';
import MyToDo from './pages/MyToDo';
import CreateOverviewPage from './pages/Overview';
import OwnerLSCReview from './pages/OwnerLSCReview';
import SiteOwner from './pages/SiteOwner';
import SiteReview from './pages/SiteReview';
import UserManagement from './pages/UserManagement';
import { errorNotification } from './reducers/handle-api-status/slice';
import { pecrData } from './reducers/pecr-info/slice';
import { userInfo } from './reducers/user-info/slice';
import { APIHeader } from './index';

function App(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { apiConfig } = props;
  const [queryClient] = React.useState(() => new QueryClient());

  useEffect(() => {
    document.title = 'P/ECR';
    fetch(`${apiConfig.uiURL}api/ProductFamilyList`, {
      headers: APIHeader(),
    })
      .then(async response => {
        const data = await response.json();
        dispatch(pecrData({ key: 'productFamilyList', value: data }));
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function FetchUserDetailsById() {
    GetUserProfileAndPermissions(
      'https://api.carrierappshub1.com/',
      'https://dev-pecr.carrier.com/',
      resp => {
        const { emailAddress, firstName, lastName } = resp;
        let { userId } = resp;
        userId === null && (userId = 0);
        if (emailAddress) {
          const loginUserName = `${firstName} ${lastName}`;
          fetch(`${apiConfig.uiURL}api/CheckUserExists`, {
            headers: APIHeader(),
            method: 'POST',
            body: JSON.stringify({
              firstName: firstName,
              lastName: lastName,
              userId: userId,
              emailAddress: emailAddress,
              active: '1',
            }),
          })
            .then(async response => {
              const data = await response.json();
              const {
                Language,
                ID,
                Active,
                DepartmentID,
                DepartmentLead,
                SiteID,
                Role,
                SiteCoordinator,
                SiteName,
                FilterID,
              } = data[0];
              dispatch(
                userInfo({
                  name: loginUserName,
                  userId: userId,
                  userEmail: emailAddress,
                  language: Language,
                  userID: ID,
                  active: Active,
                  departmentID: DepartmentID,
                  departmentLead: DepartmentLead,
                  siteID: SiteID,
                  apiConfig: apiConfig,
                  role: Role,
                  siteCoordinator: SiteCoordinator,
                  siteName: SiteName,
                  filterID: FilterID,
                  actionMessageClosed: false,
                })
              );
            })
            .catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
        }
      }
    );
  }
  useEffect(() => {
    FetchUserDetailsById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Layout>
                <HomePage apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/List"
            element={
              <Layout>
                <ListPage apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/List/:id"
            element={
              <Layout>
                <ListPage apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/Overview"
            element={
              <Layout>
                <CreateOverviewPage apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/Overview/:id"
            element={
              <Layout>
                <CreateOverviewPage apiConfig={apiConfig} />
              </Layout>
            }
          />

          <Route
            path="/LocalSiteReview"
            element={
              <Layout>
                <LocalSiteReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/LocalSiteReview/:id"
            element={
              <Layout>
                <LocalSiteReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/SiteReview/:id/:uid"
            element={
              <Layout>
                <SiteReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/SiteOwner/:id/:uid"
            element={
              <Layout>
                <SiteOwner apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/Department/:id/:uid/:did/:iid"
            element={
              <Layout>
                <Department apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/EstimateReview"
            element={
              <Layout>
                <EstimateReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/OwnerLSCReview/:id/:uid"
            element={
              <Layout>
                <OwnerLSCReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/GlobalCoordinatorReview/:id"
            element={
              <Layout>
                <GlobalCoordinatorReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/ExecutionDepartment/:id/:uid/:did/:iid"
            element={
              <Layout>
                <ExecutionDepartment apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/ExecutionReview"
            element={
              <Layout>
                <ExecutionReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/FinalReview/:id/:uid"
            element={
              <Layout>
                <FinalReview apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/MyToDo"
            element={
              <Layout>
                <MyToDo apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/MyPecr"
            element={
              <Layout>
                <MyPecr apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/MyPecr/:type"
            element={
              <Layout>
                <MyPecr apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/TrackingFile"
            element={
              <Layout>
                <TrackingFile apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/UM"
            element={
              <Layout>
                <UserManagement apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/UM/:id"
            element={
              <Layout>
                <UserManagement apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/DM"
            element={
              <Layout>
                <DepartmentManagement apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/ResourceModification"
            element={
              <Layout>
                <ResourceModification apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/DetailedList"
            element={
              <Layout>
                <DetailedList apiConfig={apiConfig} />
              </Layout>
            }
          />
          <Route
            path="/DetailedList/:id"
            element={
              <Layout>
                <DetailedList apiConfig={apiConfig} />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
